module.exports = __webpack_public_path__ + "img/402.7884a198.jpg";